<template>
  <div class="w-full h-screen max-h-screen flex flex-col main-container">
    <div class="flex-1 flex h-full min-h-0">
      <div
        class="w-52 pl-2"
        id="toggle-sidebar"
        :class="!isOpenSidebar ? 'close-sidebar' : ''"
      >
        <figure class="sidebar-logo">
          <a href="/"><img src="@/assets/main-logo.png" class="img-fluid" /></a>
        </figure>
        <div class="h-1/2 overflow-auto ml-2">
          <ComponentList
            hideAddComponent
            v-if="currentComponent"
            :components="[currentComponent]"
            :currentComponent="currentComponent"
          />
        </div>
      </div>
      <div
        id="wrapper-content"
        class="w-full h-screen overflow-hidden"
        :class="!isOpenSidebar ? 'ml-0' : 'content-wrapper-margin'"
      >
        <PageHeader
          :showSettings="true"
          :component="currentComponent"
          @toggleSidebar="toggleSidebar"
          @save="save"
        />
        <div class="component-wrapper">
          <div class="mx-3 mt-3">
            <SiteSelfSettings
              v-if="currentComponent"
              :currentComponent="currentComponent"
              :isComponentView="true"
              @update:settings="setSettings"
              @set="setProps"
              @update="handleSourceUpdate"
              @remove="handleRemoveDataSource"
              @add="handleAddDataSource"
              @addMethod="handleAddMethod"
              @updateMethod="handleUpdateMethod"
              @removeMethod="handleRemoveMethod"
              @addComputed="handleAddComputed"
              @updateComputed="handleUpdateComputed"
              @removeComputed="handleRemoveComputed"
              @addWatch="handleAddWatch"
              @updateWatch="handleUpdateWatch"
              @removeWatch="handleRemoveWatch"
            />
          </div>

          <div
            v-if="currentComponent"
            class="p-3 drag-container component-container"
          >
            <div class="w-full mb-8" id="drag-left">
              <div class="theme-toggle-container">
                <label class="theme-toggle">
                  <input
                    type="checkbox"
                    @change="toggleTheme"
                    :checked="currentTheme === 'vs-dark'"
                  />
                  <span class="slider">
                    <span class="icon sun">☀︎</span>
                    <span class="icon moon">⏾</span>
                  </span>
                </label>
              </div>

              <div class="h-100">
                <TemplateEditor
                  v-if="currentComponent"
                  :template="currentComponent.template"
                  :currentTheme="currentTheme"
                  @set="updateTemplate"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as compService from '../service/component'
import PageHeader from './components/PageHeader'
import TemplateEditor from "../components/TemplateEditor.vue";
import SiteSelfSettings from "../components/SiteSelfSettings.vue";
import ComponentList from '../components/ComponentList.vue';

export default {
  name: "GlobalComponents",
  components: {
    PageHeader,
    ComponentList,
    TemplateEditor,
    SiteSelfSettings
  },
  data () {
    return {
      currentTheme: "vs-dark",
      loading: false,
      isOpenSidebar: true,
      currentComponent: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      const { id } = this.$route.params
      this.loading = true
      const res = await compService.getComponent(id)
      console.log('res', res)
      this.currentComponent = res
      this.loading = false
    },
    toggleSidebar() {
      this.isOpenSidebar = !this.isOpenSidebar
    },
    updateTemplate(code) {
      this.currentComponent.template = code;
    },
    setProps(list) {
      this.currentComponent.props = list;
    },
    setDeps(list) {
      this.currentComponent.deps = list;
    },
    setSettings(settings) {
      Object.keys(settings).forEach((field) => {
        this.currentComponent[field] = settings[field];
      });
    },
    handleSourceUpdate({ idx, data }) {
      this.currentComponent.data[idx] = data;
    },
    handleRemoveDataSource(idx) {
      this.currentComponent.data.splice(idx, 1);
    },
    handleAddDataSource({ name, type }) {
      let remoteItem = {};
      if (type === "remote") {
        remoteItem = {
          method: "GET",
          resolve: {
            section: "res",
            url_params: [],
            headers: [],
          },
        };
      }
      this.currentComponent.data.push({
        key: name,
        type,
        ...remoteItem,
        default_value: null,
      });
    },
    handleAddMethod({ name }) {
      this.currentComponent.methods.push({
        name,
        body: "",
      });
    },
    handleUpdateMethod({ key, index, value }) {
      switch (key) {
        case "name":
          this.currentComponent.methods[index]["name"] = value;
          break;
        case "body":
          this.currentComponent.methods[index]["body"] = value;
          break;
      }
    },
    handleRemoveMethod({ index }) {
      this.currentComponent.methods.splice(index, 1);
    },
    handleAddComputed({ name }) {
      this.currentComponent.computed.push({
        name,
        body: "",
      });
    },
    handleUpdateComputed({ key, index, value }) {
      switch (key) {
        case "name":
          this.currentComponent.computed[index]["name"] = value;
          break;
        case "body":
          this.currentComponent.computed[index]["body"] = value;
          break;
      }
    },
    handleRemoveComputed({ index }) {
      this.currentComponent.computed.splice(index, 1);
    },
    handleAddWatch({ name }) {
      this.currentComponent.watch.push({
        name,
        body: "",
      });
    },
    handleUpdateWatch({ key, index, value }) {
      switch (key) {
        case "name":
          this.currentComponent.watch[index]["name"] = value;
          break;
        case "body":
          this.currentComponent.watch[index]["body"] = value;
          break;
      }
    },
    handleRemoveWatch({ index }) {
      this.currentComponent.watch.splice(index, 1);
    },
    async save(resolve) {
      await compService.updateComponent(
        this.currentComponent._id,
        {
          component: this.currentComponent
        }
      )
      resolve && resolve();
      this.$notify("Saved.");
    }
  }
}
</script>
<style lang="scss" scoped>
.main-container {
  background: #f8f8ff;
  height: 100vh;
  overflow: hidden;
}
.settings-wrapper {
  width: 30%;
}
// #drag-left {
//   width: 70%;
// }

.close-sidebar {
  margin-left: -260px !important;
}
.component-container {
  background: #f8f8ff;
  flex: 1;
  overflow: auto;
  min-height: 0;
}
.component-wrapper {
  overflow: hidden !important;
  height: calc(100vh - 40px);
  display: flex;
  flex-direction: column;
}

/* Toggle Container */
.theme-toggle-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
}

/* Toggle */
.theme-toggle {
  position: relative;
  width: 36px; /* Slightly larger width */
  height: 16px; /* Slightly larger height */
}

.theme-toggle input {
  display: none;
}

.theme-toggle .slider {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #00aeef; /* Light blue background */
  border-radius: 16px; /* Adjusted for larger height */
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.theme-toggle input:checked + .slider {
  background-color: #2d2d2d; /* Dark background for dark mode */
}

.theme-toggle .slider:before {
  content: "";
  position: absolute;
  width: 14px; /* Larger circle size */
  height: 14px; /* Larger circle size */
  background-color: white; /* Circle color */
  border-radius: 50%;
  top: 1px; /* Centered vertically */
  left: 1px; /* Padding inside slider */
  transition: transform 0.3s ease;
}

.theme-toggle input:checked + .slider:before {
  transform: translateX(20px); /* Adjusted for larger width */
}

/* Icons */
.theme-toggle .slider .icon {
  position: absolute;
  font-size: 11px; /* Larger icon size */
  transition: opacity 0.3s ease;
}

.theme-toggle .slider .sun {
  left: 2.5px; /* Adjusted for larger size */
  top: 50%;
  transform: translateY(-50%);
  color: black; /* Sun is black */
  opacity: 1;
}

.theme-toggle input:checked + .slider .sun {
  opacity: 0;
}

.theme-toggle .slider .moon {
  right: 3px; /* Adjusted for larger size */
  top: 50%;
  transform: translateY(-50%);
  color: black; /* Moon is black */
  opacity: 0;
}

.theme-toggle input:checked + .slider .moon {
  opacity: 1;
}
</style>
